import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pcbanner-template1",
    style: {
      backgroundColor: _vm.formData.pcBgColor || "#FFFFFF"
    }
  }, [_c("div", {
    staticClass: "body",
    style: {
      padding: "0px " + (_vm.formData.pcHorizontalPadding || 0) + "px"
    }
  }, [_vm.formData.pathLink.length == 0 ? _c("img", {
    style: {
      height: _vm.formData.pcHeight + "px",
      width: "100%",
      objectFit: "contain"
    },
    attrs: {
      src: _vm.noImg,
      alt: ""
    }
  }) : _c("div", {
    staticClass: "banner_bg"
  }, [_vm._l(_vm.moduleData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "bg_wrapper",
      style: {
        marginBottom: (_vm.formData.pcBannerVerticalSpace || 0) + "px"
      }
    }, _vm._l(item, function (item2, i2) {
      return _c("div", {
        key: i2,
        staticClass: "div_img_bg",
        style: {
          width: item2.outWidth,
          height: item2.height,
          margin: "0 ".concat(item2.padding)
        },
        attrs: {
          "data-index": i2
        }
      }, [_c("div", {
        ref: "content_bg" + index,
        refInFor: true,
        staticClass: "div_content_bg",
        on: {
          mouseenter: function mouseenter($event) {
            return _vm.handleBannerEnter("content_bg" + index, i2);
          },
          mouseleave: function mouseleave($event) {
            return _vm.handleBannerLeave("content_bg" + index, i2);
          }
        }
      }, [_c("div", {
        staticClass: "div_banner_small",
        style: [item.styleSmall, _vm.imgConfig]
      }), _c("YYImage", {
        staticClass: "div_banner",
        attrs: {
          fit: "cover",
          lazy: false,
          src: _vm.imgHost + item2.imgpath
        }
      }), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()], 1), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()]);
    }), 0);
  })], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };